import { FC, useRef } from 'react'
import { Line } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Container } from './AlertsOverTime.styles'
import {
    SectionTitle,
    SectionHeader,
    SectionHeaderContent,
    Card,
} from '../../overview.styles'
import { useAlertsOverTime } from './useAlertsOverTime/useAlertsOverTime'
import { MdrModule } from '@/core/modules/mdr/mdr.module'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ChartDataLabels
)

export const AlertsOverTime: FC = () => {
    const timeRange = MdrModule.getTimeRange()
    const chartRef = useRef<any>(null)
    const { data, options } = useAlertsOverTime(timeRange, chartRef)

    return (
        <Container>
            <SectionHeader>
                <SectionHeaderContent>
                    <SectionTitle variant="m-semibold" component="h2">
                        Alerts Over Time
                    </SectionTitle>
                </SectionHeaderContent>
            </SectionHeader>
            <Card className="alerts-over-time-card">
                <Line ref={chartRef} data={data} options={options} />
            </Card>
        </Container>
    )
}
